import * as React from "react";
import { SVGProps } from "react";

const Veil = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlSpace="preserve"
    viewBox="0 0 247 214"
    {...props}
  >
    <path
      fill="none"
      stroke="#ababab"
      strokeMiterlimit={1.333}
      strokeWidth={0.333}
      d="M153.5 132.4v-.7"
    />
    <defs>
      <path
        id="a"
        d="M208.8 66.7 247.3 0c-9.6 1.2-19 4.1-27.7 8.4-7.4 14.5-7.6 29.1-16.5 42.1-31.3 46-83.9 60.3-130 30.1C46.6 63.3 30.7 18.5 27.7 8.4 19 4.1 9.6 1.2 0 0c12.8 22.2 25.7 44.5 38.5 66.7 46.9 16.5 78.1 73.4 84.9 117 6-50.3 41.5-97.5 85.4-117z"
      />
    </defs>
    <clipPath id="b">
      <use xlinkHref="#a" overflow="visible" />
    </clipPath>
    <g clipPath="url(#b)">
      <linearGradient
        id="c"
        x1={-880.693}
        x2={-879.693}
        y1={711.856}
        y2={711.856}
        gradientTransform="rotate(90 -15451.012 146386.27) scale(183.7613)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#0090ff" />
        <stop offset={1} stopColor="#0a3979" />
      </linearGradient>
      <path
        fill="url(#c)"
        d="M208.8 66.7 247.3 0c-9.6 1.2-19 4.1-27.7 8.4-7.4 14.5-7.6 29.1-16.5 42.1-31.3 46-83.9 60.3-130 30.1C46.6 63.3 30.7 18.5 27.7 8.4 19 4.1 9.6 1.2 0 0c12.8 22.2 25.7 44.5 38.5 66.7 46.9 16.5 78.1 73.4 84.9 117 6-50.3 41.5-97.5 85.4-117"
      />
    </g>
    <defs>
      <path
        id="d"
        d="M208.8 66.7c-64.1 17.4-102.1 83.3-85.1 147.5l85.1-147.5z"
      />
    </defs>
    <clipPath id="e">
      <use xlinkHref="#d" overflow="visible" />
    </clipPath>
    <g clipPath="url(#e)">
      <linearGradient
        id="f"
        x1={-874.149}
        x2={-873.149}
        y1={717.303}
        y2={717.303}
        gradientTransform="translate(78057.008 -63812.879) scale(89.158)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#0090ff" />
        <stop offset={0.96} stopColor="#084a93" />
        <stop offset={1} stopColor="#084a93" />
      </linearGradient>
      <path
        fill="url(#f)"
        d="M208.8 66.7c-64.1 17.4-102.1 83.3-85.1 147.5l85.1-147.5"
      />
    </g>
    <defs>
      <path id="g" d="m38.5 66.7 85.1 147.5c17-64.2-21-130-85.1-147.5z" />
    </defs>
    <clipPath id="h">
      <use xlinkHref="#g" overflow="visible" />
    </clipPath>
    <g clipPath="url(#h)">
      <linearGradient
        id="i"
        x1={-880.473}
        x2={-879.473}
        y1={710.968}
        y2={710.968}
        gradientTransform="rotate(90 -12489.105 117408.66) scale(147.456)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#0090ff" />
        <stop offset={0.96} stopColor="#084a93" />
        <stop offset={1} stopColor="#084a93" />
      </linearGradient>
      <path
        fill="url(#i)"
        d="m38.5 66.7 85.1 147.5c17-64.2-21-130-85.1-147.5"
      />
    </g>
    <defs>
      <path
        id="j"
        d="M205.5 51.1c8-12.9 12.9-27.5 14.2-42.7-20.9 10.4-36.9 28.7-44.3 50.8-16.6 49.7-86.8 49.7-103.4 0-7.5-22.1-23.4-40.4-44.3-50.7 4.5 53 51.1 92.3 104.1 87.8a96.43 96.43 0 0 0 73.7-45.2z"
      />
    </defs>
    <clipPath id="k">
      <use xlinkHref="#j" overflow="visible" />
    </clipPath>
    <g clipPath="url(#k)">
      <linearGradient
        id="l"
        x1={-883.445}
        x2={-882.445}
        y1={722.981}
        y2={722.981}
        gradientTransform="rotate(-90 -70729.17 -7089.541) scale(88.1949)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#13d5d2" />
        <stop offset={0.43} stopColor="#12e0e4" />
        <stop offset={1} stopColor="#76bdff" />
      </linearGradient>
      <path
        fill="url(#l)"
        d="M205.5 51.1c8-12.9 12.9-27.5 14.2-42.7-20.9 10.4-36.9 28.7-44.3 50.8-16.6 49.7-86.8 49.7-103.4 0-7.5-22.1-23.4-40.4-44.3-50.7 4.5 53 51.1 92.3 104.1 87.8a96.43 96.43 0 0 0 73.7-45.2"
      />
    </g>
  </svg>
);

export default Veil;
